import React from 'react';
import uniqid from 'uniqid';

import { StudentDetails } from './StudentWatchedPercentageDetails';

const createStudentDetailsList = (studentProgress) => {
  const studensWhoHasNotStarted = [];
  const studentsWhoHasStarted = [];
  const studentsWhoHasCompleted = [];
  studentProgress.forEach((studentDetails) => {
    const {
      watched_percentage: watchedPercentage,
      first_name: firstName,
      last_name: lastName,
    } = studentDetails;
    if (watchedPercentage >= 95) {
      studentsWhoHasCompleted.push(
        <StudentDetails
          key={uniqid()}
          firstName={firstName}
          lastName={lastName}
          watchedPercentage={watchedPercentage}
        />,
      );
    } else if (watchedPercentage > 0 && watchedPercentage < 95) {
      studentsWhoHasStarted.push(
        <StudentDetails
          showWatchedPercentage
          key={uniqid()}
          firstName={firstName}
          lastName={lastName}
          watchedPercentage={watchedPercentage}
        />,
      );
    } else {
      studensWhoHasNotStarted.push(
        <StudentDetails
          key={uniqid()}
          firstName={firstName}
          lastName={lastName}
          watchedPercentage={watchedPercentage}
        />,
      );
    }
  });
  return {
    studensWhoHasNotStarted,
    studentsWhoHasStarted,
    studentsWhoHasCompleted,
  };
};

export default createStudentDetailsList;
